<div class="tab-body">
  <form [formGroup]="addCapitalUsageRequirementForm">
    <div class="form-inputs form-padding">
      <div class="field-info">
        <p class="paragraph-medium-regular">
          Do you require additional space allocation to your division/cluster for the current intended line item? * 
          <mat-icon tp="{{ tooltipInfoSpaceRequirement }}" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
        </p>
      </div>
        <mat-button-toggle-group name="IsAdditionalSpaceRequired" 
          (change)="IsSpaceRequirementControlChange($event)" [disabled]="isReadOnly">
          <mat-button-toggle [value]="true" [checked]="IsAdditionalSpaceRequired.value=== true">Yes</mat-button-toggle>
          <mat-button-toggle [value]="false" [checked]="IsAdditionalSpaceRequired.value=== false">No</mat-button-toggle>
        </mat-button-toggle-group>
   

    </div>
    <div class="form-inputs mt-4">
      <p class="paragraph-medium-regular">Estimated usage of asset *</p>
      <ng-select [items]="estimatedUsages" bindLabel="Name" appearance="outline"
        formControlName="EstimatedUsageId" 
        [readonly]="isReadOnly">
        <ng-template ng-option-tmp let-item="item">
          <div>
            <span style="float: left;">{{item.Name}}</span>
            <span style="float: right;"></span>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-inputs form-padding">
      <p class="paragraph-medium-regular">Annual maintenance (SGD) *</p>
      <input class="normal-txtbox" type="number" min="0" max="9999999999999.999" formControlName="AnnualMaintenanceCost" step="0.001"
        placeholder="0.000" (input)="restrictNegativeNumberInput($event, 3)"
        [readonly]="isReadOnly" />
    </div>
    <div class="form-inputs form-padding mt-4">
      <div class="field-info">
        <p class="paragraph-medium-regular"> Will this line item support any projects that are not funding this purchase? * </p>
      </div>
      <mat-button-toggle-group name="IsSupportingNonFundingProject"  
      [disabled]="isReadOnly"  (change)="IsProjectCofundingControlChange($event)">
          <mat-button-toggle [value]="true"  [checked]="IsSupportingNonFundingProject.value=== true">Yes</mat-button-toggle>
          <mat-button-toggle [value]="false" [checked]="IsSupportingNonFundingProject.value=== false">No</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="form-inputs form-padding mt-4">
      <p class="paragraph-medium-regular">Please specify the projects and their reasons for not funding this purchase.*</p>
      <app-text-input [control]="SupportingInformation"
      [maxCharCount]="1500"
      [isReadOnly]="IsSupportingNonFundingProject.value=== false ? true : reasonDescriptionReadOnly"
      placeHolderText=""
      class="text-field"
    ></app-text-input>
    </div>
  </form>
  </div>
    